export const GET_MENU = "GET_MENU";
export const APPLY_MENU = "APPLY_MENU";